import { lazy } from 'react';
import i18next from 'i18next';
import en from './i18n/en';
import bg from './i18n/bg';

const RoomieAIApp = lazy(() => import('./RoomieAIApp'));

i18next.addResourceBundle('en', 'roomieAIPage', en);
i18next.addResourceBundle('bg', 'roomieAIPage', bg);

/**
 * The RoomieAI app config.
 */
const RoomieAIConfig = {
    settings: {
        layout: {}
    },
    auth: ['Godfather', 'Admin', 'Reception', 'Main Cleaner'],
    routes: [
        {
            path: 'roomie-ai',
            element: <RoomieAIApp />
        }
    ]
};

export default RoomieAIConfig; 